import React, { useState } from 'react';
import { Modal, Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import AlertsClientes from '../Utils/AlertsClientes';
import Departamentos from '../../../../utils/places-colombia';
import APIserver from '../../../../api/axiosConfig';

function ClienteModal({ show, handleClose }) {
    const [selectedDepartamento, setSelectedDepartamento] = useState(null);
    const [selectedCiudad, setSelectedCiudad] = useState(null);
    const [clienteId, setClienteId] = useState('');
    const [nomCliente, setNomCliente] = useState('');
    const [numCliente, setNumCliente] = useState('');
    const [direccion, setDireccion] = useState('');
    const [correoCliente, setcorreoCliente] = useState('');
    const [ciudadesOptions, setCiudadesOptions] = useState([]);

    // Predefinir el país como Colombia (sin necesidad de mostrarlo en el formulario)
    const [selectedPais] = useState({ value: 'Colombia', label: 'Colombia' });

    const handleDepartamentoChange = (selectedOption) => {
        setSelectedDepartamento(selectedOption);
        const departamento = Departamentos.find(dep => dep.departamento === selectedOption.value);
        const ciudades = departamento ? departamento.ciudades.map(ciudad => ({ value: ciudad, label: ciudad })) : [];
        setCiudadesOptions(ciudades);
        setSelectedCiudad(null);
    };

    const handleCiudadChange = (selectedOption) => {
        setSelectedCiudad(selectedOption);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Definir el objeto clienteData sin enviar el país
        const clienteData = {
            clienteId,
            nomCliente,
            correoCliente,
            numCliente,
            ciudad: selectedCiudad ? selectedCiudad.value : '',
            departamento: selectedDepartamento ? selectedDepartamento.value : '',
            direccion,
            // No incluimos el país en el clienteData
        };

        try {
            const response = await APIserver.post(`/api/clientes`, clienteData);
           // console.log(response);

            if (response.status >= 200 && response.status < 300) {
                AlertsClientes.showSuccessMessage('Cliente creado exitosamente');
                handleClose();
            } else {
                throw new Error('Error al crear el cliente');
            }
        } catch (error) {
            console.error('Error al crear el cliente:', error);
            AlertsClientes.showErrorMessage('Error al procesar la solicitud del cliente');
        }
    };

    const departamentosOptions = Departamentos.map(departamento => ({ value: departamento.departamento, label: departamento.departamento }));

    return (
        <Modal size='lg' show={show} onHide={handleClose} aria-labelledby='create-new-client-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Crear Nuevo Cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit}>
                    <Row>
                        <Col xs={12} md={6}>
                            <Form.Group className='m-3 mt-0' controlId='clienteID'>
                                <Form.Label>Identificación</Form.Label>
                                <Form.Control type='number' placeholder='Número de identificación' value={clienteId} onChange={(e) => setClienteId(e.target.value)} required />
                            </Form.Group>
                            <Form.Group className='m-3' controlId='nomCliente'>
                                <Form.Label>Nombre Completo</Form.Label>
                                <Form.Control type='text' placeholder='Nombre Completo' value={nomCliente} onChange={(e) => setNomCliente(e.target.value)} required />
                            </Form.Group>
                            <Form.Group className='m-3' controlId='numCliente'>
                                <Form.Label>Número de Celular</Form.Label>
                                <Form.Control type='number' placeholder='Número de Celular' value={numCliente} onChange={(e) => setNumCliente(e.target.value)} required />
                            </Form.Group>
                            <Form.Group className='m-3' controlId='correoCliente'>
                                <Form.Label>Correo Electrónico</Form.Label>
                                <Form.Control type='email' placeholder='usuario@example.com' value={correoCliente} onChange={(e) => setcorreoCliente(e.target.value)} required />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Group className='m-3 mt-0' controlId='departamento'>
                                <Form.Label>Departamento</Form.Label>
                                <Select options={departamentosOptions} value={selectedDepartamento} onChange={handleDepartamentoChange} placeholder='Seleccione' isClearable required />
                            </Form.Group>
                            <Form.Group className='m-3' controlId='ciudad'>
                                <Form.Label>Ciudad</Form.Label>
                                <Select options={ciudadesOptions} value={selectedCiudad} onChange={handleCiudadChange} placeholder='Seleccione' isClearable required />
                            </Form.Group>
                            <Form.Group className='m-3' controlId='direccion'>
                                <Form.Label>Dirección</Form.Label>
                                <Form.Control type='text' placeholder='Dirección' value={direccion} onChange={(e) => setDireccion(e.target.value)} required />
                            </Form.Group>
                            {/* El campo de país ahora está oculto */}
                            <Form.Group className='m-3 d-none' controlId='pais'>
                                <Form.Label>Pais</Form.Label>
                                <Select options={[]} value={selectedPais} onChange={() => { }} isDisabled />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Modal.Footer>
                        <Button variant='dark' onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant='danger' type='submit'>
                            Guardar
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ClienteModal;
